import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './auth.guard';
import {EzPainelComponent} from './modulos/integracao-ezpoint/ez-painel/ez-painel.component';
import {MsalGuard} from '@azure/msal-angular';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((x) => x.LoginModule),
  },
  {
    path: 'painel',
    loadChildren: () =>
      import('./shared/principal/principal.module').then(
        (x) => x.PrincipalModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'ponto',
    loadChildren: () =>
      import('./shared/ponto/ponto.module').then((x) => x.PontoModule),
    // component: PontoComponent,
    canActivate: [AuthGuard] //, MsalGuard],
  },
  {
    path: 'pontoManual',
    loadChildren: () =>
      import('./shared/ponto-manual/ponto-manual.module').then((x) => x.PontoManualModule),
    // component: PontoComponent,

    canActivate: [AuthGuard],
  },
  {
    path: 'ez',
    component: EzPainelComponent,
    loadChildren: () =>
      import('./modulos/integracao-ezpoint/ez.module').then((x) => x.EzModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/painel/painel.module').then((x) => x.PainelModule),
    canActivate: [AuthGuard],
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {enableTracing: false, useHash: true, initialNavigation: 'enabledNonBlocking'}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
